import { baseDeleteQuery } from '../../../../utility/sb-api/sb-api.service';

export const removeAddition = (id, storeId, onSuccessCallback = () => undefined) => {
  baseDeleteQuery(
    `manager/stores/${storeId}/item-additions/food/${id}`,
    null,
    'removeAdditionSuccess',
    'removeAdditionError',
  ).then(() => onSuccessCallback());
};

export const removeAdditionGroup = (
  id,
  storeId,
  onSuccessCallback = () => undefined,
) => {
  baseDeleteQuery(
    `manager/stores/${storeId}/item-addition-groups/${id}`,
    null,
    'removeAdditionSuccess',
    'removeAdditionError',
  ).then(() => onSuccessCallback());
};

export const removeAdditionGroupEntry = (
  id,
  storeId,
  onSuccessCallback = () => undefined,
) => {
  baseDeleteQuery(
    `manager/stores/${storeId}/item-addition-group-entries/${id}`,
    null,
    'removeAdditionSuccess',
    'removeAdditionError',
  ).then(() => onSuccessCallback());
};
